<template>
  <div id="Home">
    <BannerRow>
      <div class="col-7 col-md-6 col-lg-6 col-xl-6 d-flex align-items-center mt-5 mb-5 mt-0 mb-0">
        <div class="header ml-0 ml-md-5 w-100">
          <h2 class="mb-4 primary-heading">{{$t("home.main_title")}}</h2>
          <div class="pb-3">
            <p v-html="$t('home.main_des')"></p>
          </div>
          <div class="mt-4 d-lg-flex flex-lg-row">
              <a :href="urlDownloadAppNow" target="_top" class="btn-custom  mb-2 mr-lg-3 download-app w-100 btn btn-secondary text-white font-weight-bold" >{{$t("home.btn_download_app")}}</a>
              <a target="_top" class="btn-custom find-provider w-100 btn btn-white  border-secondary font-weight-bold text-secondary" href="browse">{{$t("home.btn_find_provider")}}</a>
              <!-- <a class="btn-custom btn-register-provider btn btn-white border-secondary font-weight-bold text-secondary" href="providers">{{$t("home.btn_register_provider")}}</a> -->
          </div>
        </div>  
      </div>
      <div class="col-5 col-md-6 col-lg-6 col-xl-6 banner-image">
      </div>
    </BannerRow>
    <WhiteRow>
      <!-- HOME WHITE ROW -->
      <div class="home ml-0 ml-md-5">
        <div class="row no-gutters mt-5 mb-5">
          <div class="col-12">
            <h2 class="mb-4 text-secondary font-weight-bold primary-heading">
              <p v-html="$t('home.content_title')"></p>
            </h2>
            <div class="row no-gutters mb-5 mt-4">
              <div class="col-5 col-lg-4 d-flex align-items-center">
                <div class="step-image">
                    <img class="img-fluid" src="../assets/sink.png" alt="sink">
                </div>
              </div>
              <div class="col-6 col-lg-7 offset-1 d-flex align-items-center justify-content-end">
                <div class="text-right">
                   <p v-html="$t('home.step1')"></p>
                </div>  
              </div>
            </div>

            <div class="row not-gutters mb-5">
              <div class="col-7 col-lg-8 d-flex align-items-center">
                  <div class="box-step">
                       <p v-html="$t('home.step2')"></p>
                  </div>
                </div>
                <div class="col-5 col-lg-4 d-flex align-items-center">
                  <div class="step-image">
                    <img src="../assets/app-3d.png" class="img-fluid" alt="app-3d" />
                  </div>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col-5 col-lg-4 d-flex align-items-center">
                <div class="step-image">
                    <img src="../assets/sink-fixed.png" class="img-fluid" alt="sink-fixed"/>
                </div>
              </div>
              <div class="col-6 col-lg-7 offset-1 d-flex align-items-center justify-content-end">
                <div class="text-right">
                  <div class="box-step">
                       <p v-html="$t('home.step3')"></p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </WhiteRow>
    <HalfYellowRow>
      <template slot="left">
        <div class="left ml-0 ml-md-5 mr-2">
          <div class="row no-gutters mt-5 mb-5 pt-3">
            <div class="col-12">
              <div class="text-secondary">
                  <p v-html="$t('home.title2')"></p>
              </div>
              <div class="d-lg-none">
                <div class="text-secondary font-weight-bold primary-heading mt-3 mb-2">
                  {{$t('home.register_now')}}
                </div>
                <a href="providers" class="btn btn-custom btn-block btn-secondary text-uppercase">{{$t('home.btn_register_now')}}</a>            
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="right">
        <div class="content d-none d-lg-block">
          <div class="row no-gutters mt-5 mb-5">
             <div class="col-12">
                <div class="text-secondary font-weight-bold primary-heading">
                  {{$t('home.register_now')}}
                </div>
                <!-- <a href="providers" class="mt-3 btn btn-custom font-weight-bold btn-block text-uppercase text-secondary bg-primary">{{$t('home.btn_register_now')}}</a>  -->
             </div>
          </div>
        </div>
      </template>
    </HalfYellowRow>
    <div class="content"> 
        <div class="row d-flex justify-content-lg-center mb-3 mt-4 mt-lg-5">
          <div class="col-12">
               <h2 class="text-secondary text-lg-center primary-heading">{{$t('home.call_download')}}</h2>
          </div>
        </div>
        <div class="row d-flex justify-content-lg-center">
          <div class="col-12 d-flex justify-content-center">
            <div id="download-app" class="download-app">
              <a ref="googlePlay"  class="google-play mr-lg-4 mr-sm-3" href="https://play.google.com/store/apps/details?id=vn.oddjob.app">
                <img src="../assets/google-play.svg" alt="google play" />
              </a>
              <a ref="appStore"  class="app-store" href="https://apps.apple.com/vn/app/oddjob-vn/id1520359924">
                <img src="../assets/app-store.svg" alt="app store" />
              </a>
            </div>
          </div>
        </div>
        <div class="row d-flex justify-content-center mt-5">
          <div class="col-12 col-lg-7 col-xl-6">
             <div class="text-secondary text-content text-center">
                {{$t('home.note_download')}}
             </div>
          </div>
        </div>
        <div class="row d-flex justify-content-center mt-2 mb-4 mb-lg-5">
          <div class="col-12 col-lg-6 col-xl-5">
             <a class="btn btn-custom btn-block border-secondary text-uppercase text-secondary font-weight-bold find-provider" href="browse">{{$t('home.btn_find_provider_now')}}</a>
          </div>
        </div> 
        <!-- <div class="row d-flex justify-content-lg-center mb-3 mt-4 mt-lg-5">
          <div class="col-12 col-lg-11">
               <h2 class="text-secondary text-center primary-heading">
                  {{$t('home.subscriber.title')}}
                  <span class="d-block mt-2">{{$t('home.subscriber.sub_title')}}</span>
               </h2>
          </div>
        </div>
        <div class="row d-flex justify-content-center mt-2 mb-4 mb-lg-5">
          <div class="col-12 col-lg-10 col-xl-8">
              <div class="mb-2 mb-lg-3 font-weight-bold caption text-lg-center">
                {{$t('home.subscriber.caption_email_or_phone_number')}}
              </div>
          </div>
          <div class="col-12 col-lg-7 col-xl-6">
           <div class="row no-gutters d-flex justify-content-center">
                <div class="col-12 col-lg-8 col-xl-8">
                    <input ref="emailOrPhoneNumber" maxlength="256" v-model="emailOrPhoneNumber" class="input-email form-control d-inline-block" type="text" :placeholder="$t('home.subscriber.placeholder_email_or_phone_number')" name="email">
                    <div v-if="error" ref="subscribleError" :class="hasError ? 'text-danger': 'text-success'" class="error d-inline-block pt-2">{{error}}</div>
                </div>
                <div class="col-12 ml-0 ml-lg-2 col-lg-3 col-xl-3">
                  <button :disabled="!validated" type="submit" @click="createSubscriber()" class="btn text-uppercase submit-email text-light btn-block btn-primary mt-3 mb-4 mt-lg-0 mb-lg-0">{{$t("home.subscriber.submit")}}</button>
                </div>
              </div>
          </div>
        </div>  -->
    </div>
    <PopupHomePage ref="popupHomePage"></PopupHomePage>
  </div>
</template>

<style lang="scss" scoped>
// .app-store {
//   pointer-events: none;
//   cursor: default;
//   opacity: 0.4;
// }

.input-email,
.submit-email {
  height: 55px;
}
.submit-email {
  background-color: black;
  border-color: black;
  cursor: pointer;
}
.submit-email:hover {
  opacity: 0.9;
}
.submit-email:disabled,
.submit-email[disabled] {
  background-color: black;
  border-color: black;
  opacity: 0.7;
}

.banner-image {
  background: url("../assets/phones.png") no-repeat left center;
  background-size: cover;
  min-height: 300px;
  border-radius: 50px;
  background-position-x: -1px;
}
.caption {
  font-size: 16px;
}
#Home {
  font-size: 1.1rem;
  color: #000000;
}

.caption {
  font-size: 16px;
}
.error {
  font-size: 13px;
}

.text-content {
  font-size: 1rem;
}

.primary-heading {
  font-size: 1.32rem;
  font-weight: bold;
}

.btn-custom {
  font-size: 0.7rem;
  padding: 15px;
  border-radius: 16px;
}

.content {
  position: relative;
  z-index: 1;
  padding: 15px;

  .find-provider {
    border-width: 2px;
    opacity: 1;
    &:hover {
      opacity: 0.8;
    }
  }
}

.header {
  .btn-register-provider {
    border-width: 2px;
    opacity: 1;
    padding: 11px 4px;
    width: 100%;
    &:hover {
      opacity: 0.8;
    }
  }

  .find-provider {
    border-width: 2px;
    opacity: 1;
    max-height: 47px;
    height: 47px;
    padding: 13px 0px;
    &:hover {
      opacity: 0.8;
    }
  }
  .download-app {
    opacity: 1;
    max-height: 47px;
    height: 47px;
    padding: 13px 0px;
    &:hover {
      opacity: 0.8;
    }
  }
}

.home {
  .step-title {
    font-size: 1.32rem;
  }
}

@media screen and (min-width: 576px) {
  .content {
    .download-app {
      a {
        img {
          height: 50px;
        }
      }
    }
  }
}
@media screen and (min-width: 768px) {
  #Home {
    font-size: 1.3rem;
  }

  .primary-heading {
    font-size: 1.55rem;
  }

  .home {
    .step-title {
      font-size: 1.55rem;
    }
  }
}
@media screen and (min-width: 992px) {
  .primary-heading {
    font-size: 1.65rem;
  }

  #Home {
    font-size: 1.5rem;
  }

  .home {
    .step-title {
      font-size: 1.65rem;
    }
  }

  .btn-custom {
    font-size: 0.8rem;
  }

  .header {
    .btn-register-provider {
      // max-height: 48px;
      // height: 48px;
      padding: 11px 0px;
      width: 75%;
      &:hover {
        opacity: 0.8;
      }
    }
    .find-provider {
      max-height: 50px;
      height: 50px;
    }
    .download-app {
      max-height: 50px;
      height: 50px;
    }
  }

  .content {
    .download-app {
      a {
        img {
          height: 55px;
        }
      }
    }
  }
}
@media screen and (min-width: 1200px) {
  .primary-heading {
    font-size: 1.8rem;
  }

  .banner-image {
    min-height: 450px;
  }

  .btn-custom {
    font-size: 1rem;
  }

  .header {
    .find-provider {
      max-height: 53px;
      height: 53px;
    }
    .download-app {
      max-height: 53px;
      height: 53px;
    }
  }

  #Home {
    font-size: 1.55rem;
  }

  .home {
    .step-title {
      font-size: 1.8rem;
    }
  }
}
</style>

<script>
import HalfYellowRow from "@/components/HalfYellowRow.vue";
import BannerRow from "@/components/BannerRow.vue";
import WhiteRow from "@/components/WhiteRow.vue";
import PopupHomePage from "@/components/PopupHomePage.vue";

export default {
  name: "Home",
  components: {
    HalfYellowRow,
    BannerRow,
    WhiteRow,
    PopupHomePage
  },
  data() {
    return {
      emailOrPhoneNumber: "",
      reg: {
        email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
        phoneNumber: /(?:\s+|)((0|(?:(\+|)91))(?:\s|-)*(?:(?:\d(?:\s|-)*\d{9})|(?:\d{2}(?:\s|-)*\d{8})|(?:\d{3}(?:\s|-)*\d{7}))|\d{9})(?:\s+|)/
      },
      error: "",
      validated: false,
      hasError: true,
      urlDownloadAppNow: "#download-app"
    };
  },
  watch: {
    emailOrPhoneNumber(value) {
      this.validateEmailOrPhoneNumber(value);
    }
  },
  methods: {
    validateEmailOrPhoneNumber(value) {
      if (value == null) {
        // this.error = "You have successfully subscribed";
        this.error = this.$t("home.subscriber.successfully");
        return;
      }
      this.$refs.emailOrPhoneNumber.maxLength = "254";
      this.error = "";
      this.hasError = true;
      if (
        this.reg.email.test(value) == true ||
        this.reg.phoneNumber.test(value) == true
      ) {
        if (this.reg.phoneNumber.test(value) == true) {
          this.$refs.emailOrPhoneNumber.maxLength = "10";
        }
        this.validated = true;
      } else {
        // this.error = "The field must be a valid email or phone number";
        this.error = this.$t("home.subscriber.error");
        this.$refs.emailOrPhoneNumber.focus();
        this.validated = false;
        return;
      }
    },
    async createSubscriber() {
      try {
        const {
          data: { code, message, results }
        } = await this.$store.$oddjob.customers.createSubscriber({
          subscriber: this.emailOrPhoneNumber
        });
        console.log("results", results);
        console.log("code", code);
        console.log("message", message);
        if (code === "duplicated" && message != null) {
          this.hasError = true;
          //  this.error = "The email or phone number is already subscribe";
          this.error = this.$t("home.subscriber.duplicated");
          return;
        }
        this.hasError = false;
        this.emailOrPhoneNumber = null;
        this.validated = false;
      } catch (e) {
        console.log("API create subscriber failed", e);
      }
    }
  },
  async mounted() {
    const userAgent = window.navigator.userAgent;
    if (/Android/i.test(userAgent)) {
      console.log(`vao android`);
      this.urlDownloadAppNow =
        "https://play.google.com/store/apps/details?id=vn.oddjob.app";
    }

    if (/iPhone|iPad/i.test(userAgent)) {
      console.log(`vao IoS`);
      this.urlDownloadAppNow =
        "https://apps.apple.com/vn/app/oddjob-vn/id1520359924";
    }

    // if(localStorage.language == 'vi'){
    //   this.$refs.popupHomePage.openPopupHomePage();
    // }
  }
};
</script>
